<template>
  <require from="framework/html_behaviors/af-items-loader"></require>
  <require from="framework/html_behaviors/af-sort-column"></require>
  <require from="framework/html_behaviors/af-sort-context"></require>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <require from="controls/as-table-skeleton"></require>
  <require from="components/filters/airlines-filter"></require>
  <require from="controls/as-page-jumbo.html"></require>
  <require from="controls/as-form-widget.html"></require>

  <as-page-jumbo icon="fas fa-plane-departure fa-fw" heading="Airlines administration" intro="Manage airlines settings.">
    <div slot="default">
      <as-form-widget>
        <div slot="default">
          <airlines-filter model.bind="filter" mutated.call="filterMutated()" show-archive="true"></airlines-filter>
        </div>
      </as-form-widget>
      <div class="sc-buttons-container">
        <button type="button" class="btn btn-light" af-mutex-click.call="createNewAirline()">
          <i class="fas fa-plus"></i> Create new
        </button>
      </div>
    </div>
  </as-page-jumbo>
  <div class="container-fluid">
    <table class="table table-borderless table-hover sc-table-fixed sc-table-sticky sc-list-highlight" af-sort-context.bind="sortInstruction">
      <thead>
        <tr>
          <th af-sort-column="Name">Name</th>
          <th class="d-lg-none" width="53px" af-sort-column="Code">Code</th>
          <th class="d-none d-lg-table-cell" width="135px" af-sort-column="Code">Code</th>
          <th class="d-lg-none" width="63px" af-sort-column="AirlineRating">Rating</th>
          <th class="d-none d-lg-table-cell" width="135px" af-sort-column="AirlineRating">Rating</th>
          <th class="d-md-none" width="60px" af-sort-column="AirlineStatus">Status</th>
          <th class="d-none d-md-table-cell" width="200px" af-sort-column="AirlineStatus">Status</th>
        </tr>
      </thead>
      <tbody if.bind="loaded">
        <tr class="sc-selectable ${!airline.isActive ? 'sc-archived' : ''} ${$index % 2 ? 'sc-row-even' : ''} sc-content-appear" virtual-repeat.for="airline of airlines" click.delegate="showAirline(airline)">
          <td title="${airline.name}">
            <div class="d-flex">
              <a href="#/${homeRoute & oneTime}/admin/airlines/${airline.id}" innerhtml="${airline.highlightedName | sanitizeHTML}" class="text-truncate sc-content-main"></a>
            </div>
          </td>
          <td title="${airline.code}"><span innerhtml="${airline.highlightedCode | sanitizeHTML}"></span></td>
          <td class="text-center text-lg-left" title="${airline.airlineRating.name}">
            <span class="d-none d-lg-inline-block">${airline.airlineRating.name}</span>
            <span class="d-inline-block d-lg-none">${airline.airlineRating.shortName}</span>
          </td>
          <td class="text-right text-md-left" title="${airline.airlineStatus.name}">
            <i class="fas fa-fw fa-xs mr-2 ai-airline-status ${'--status-' + airline.airlineStatus.value}"></i>
            <span class="d-none d-md-inline">${airline.airlineStatus.name}</span>
          </td>
        </tr>
      </tbody>
      <tbody as-element="as-table-skeleton" else></tbody>
    </table>
    <div class="sc-table-norows" if.bind="countries.length === 0">No items found</div>
    <af-items-loader items.bind="airlines" fetch.call="fetchAirlines(skip, take)" batch-size.bind="batchSize" template="templates/items-loader.html"></af-items-loader>
  </div>
</template>
